export class BookmarkElement {

	constructor(
		public bookmarkElementId?: number | null,
		public bookmarkId?: number,
		public key?: string,
		public value?: string,
		public operatorId?: string | null,
	) {}
}
